import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "CircleSmall__IconWrapper",
  componentId: "sc-1zgar8-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 168 168",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("circle", {
    cx: 1100,
    cy: 359,
    r: 84,
    fill: "#EDFF7A",
    fillRule: "evenodd",
    transform: "translate(-1016 -275)"
  }));
}
const CircleSmall = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(CircleSmall);
export default Memo;